"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomain = void 0;
const basic_types_1 = require("../common/basic-types");
const get_all_markets_1 = require("./get-all-markets");
const domainNamesByBrand = {
    BK: 'burgerking',
    FHS: 'firehousesubs',
    PLK: 'popeyes',
    TH: 'timhortons',
};
const marketExceptions = {
    'BK-CH': 'burger-king',
    'PLK-CH': 'popeyeschicken',
    'PLK-FR': 'popeyesfrance',
    'PLK-PL': 'popeyeschicken',
};
const getDomainName = (brand, iso2) => {
    const marketString = `${brand}-${iso2}`;
    const marketException = marketExceptions[marketString];
    if (marketException) {
        return marketException;
    }
    return domainNamesByBrand[brand];
};
/**
 * Get a market's Fully-Qualified Domain Name.
 * Note this provides a naked domain name, i.e. no `www.` is included.
 * @param brand brand code.
 * @param iso2 country code.
 * @returns market's FQDN when available, otherwise undefined.
 */
const getDomain = (brand, iso2) => {
    const supportedBrand = basic_types_1.asBrand(brand);
    if (!supportedBrand) {
        return;
    }
    const market = get_all_markets_1.allMarkets[supportedBrand].find((m) => basic_types_1.asIsoCountryCode2(m.country.iso2) === basic_types_1.asIsoCountryCode2(iso2));
    if (!market) {
        return;
    }
    const tld = market.topLevelDomain;
    const domainName = getDomainName(supportedBrand, market.country.iso2);
    return `${domainName}.${tld}`;
};
exports.getDomain = getDomain;
